import styled, { css } from 'styled-components';
import { FontSizes } from '../../../../common/typography/typography.styles';
import { getEncodedCheckMarkIconSvg } from '../../../../utils/svg/svg.utils';

export const MileNameSection = styled.div<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 2px;

  .service-name-and-price-diff {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    p {
      font-size: ${FontSizes.normal};
      color: ${({ $selected, theme }) =>
        $selected
          ? theme.colors.namedColors.primary
          : theme.colors.baseColors.grey150};
      ${({ $selected, theme }) => {
        if ($selected) {
          return css`
            color: ${theme.colors.namedColors.primary};
            font-weight: 500;
          `;
        }
        return css`
          color: ${theme.colors.baseColors.grey150};
          font-weight: 400;
        `;
      }}
    }
  }
`;

export const MileListItem = styled.div<{ $selected: boolean }>`
  display: flex;
  width: 100%;
  cursor: pointer;
  position: relative;
  justify-content: start;
  align-items: center;
  padding: 0.8rem 1.6rem;
  border-radius: 10px;
  gap: 16px;

  img {
    display: block;
    width: 40px;
    height: 40px;
    object-fit: contain;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.baseColors.grey5};
  }

  @media (max-width: 650px) {
    flex-grow: 1;
  }

  ${({ $selected }) => {
    if (!$selected) return;

    return css`
      @media (max-width: 650px) {
        background-color: ${({ theme }) => theme.colors.baseColors.grey5};
      }

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 1.6rem;
        transform: translateY(-50%);
        width: 1.2rem;
        height: 0.9rem;
        background-image: ${({ theme }) =>
          `url(${getEncodedCheckMarkIconSvg(theme.colors.namedColors.primary)})`};
        background-size: contain;
        background-repeat: no-repeat;
      }
    `;
  }}
`;

export const MilesListContainer = styled.div`
  position: relative;
  display: flex;
  width: 400px;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.namedColors.white};
  border: 1px solid ${({ theme }) => theme.colors.baseColors.grey25};
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  @media (max-width: 650px) {
    box-shadow: none;
    border: none;
    padding: 0;
    flex-grow: 1;
    width: 100%;
  }
`;
